module.exports = "/images/pt-20.svg?8f4ad4ff13d2952b33f2d50df18b0cda";